import './MarylandMatchCard.scss';

import moment from 'moment';
import React from 'react';

import { isBetweenFromAndToDates } from 'services/Dates';
import { maryland529MatchLinks } from 'services/Externals';
import LinkButton from 'components/shared/Buttons/LinkButton';
import { cwvMarylandContributionTileEnabled } from 'services/FeatureFlags';

// TODO : these default dates should be stored in view reducer
const MarylandMatchCard = ({ additionalClassName }) => {
  const isWithinWindow = isBetweenFromAndToDates(
    moment(),
    moment(moment().year() + '-01-01').startOf('day'),
    moment(moment().year() + '-05-31').endOf('day')
  );
  const windowAlmostClosed = isBetweenFromAndToDates(
    moment(),
    moment(moment().year() + '-05-01').startOf('day'),
    moment(moment().year() + '-05-31').endOf('day')
  );
  return isWithinWindow ? (
    <div className="maryland-match-background">
      <div className={`maryland-match-card ${additionalClassName}`}>
        {windowAlmostClosed ? (
          <div className="maryland-match-card-title">Apply by May 31st</div>
        ) : (
          <div className="maryland-match-card-title">
            <span className="maryland-match-card-title-border">
              Application
            </span>{' '}
            Now Open
          </div>
        )}
        <div className="maryland-match-card-content">
          You could be eligible for a $250 or $500 contribution.
        </div>
        <div className="maryland-match-card-sub-content">
          Apply now for the Save4College State Contribution Program.
        </div>
        <div className="maryland-match-card-link">
          <LinkButton
            link={maryland529MatchLinks.applyNow}
            linkTarget="_blank"
            text="Apply Now"
            withPermissions={true}
            shouldDisable={!cwvMarylandContributionTileEnabled()}
          />
          <LinkButton
            link={maryland529MatchLinks.learnMore}
            linkTarget="_blank"
            text="Learn More"
            withPermissions={true}
            shouldDisable={!cwvMarylandContributionTileEnabled()}
          />
        </div>
      </div>
    </div>
  ) : null;
};

export default MarylandMatchCard;
